module.exports = __webpack_public_path__ + "img/features-1.424682b1.png";